$easyreels_user $mol_view
	plugins /
		<= Theme $mol_theme_auto
	attr *
		^
		easyreels_user_page <= page \recorder
	sub <= content /
	Placeholder $mol_view
	Guest $mol_page
		title \Easyreels
		tools /
			<= Guest_lang $easyreels_i18n_switch
		body /
			<= Signin $easyreels_user_signin
				start? <=> sign_in? null
	Recorder $easyreels_user_recorder
		tools /
			<= Library_link $mol_link
				arg *
					page \recordings
				hint <= library_title @ \My recordings
				sub /
					<= Library_icon $mol_icon_filmstrip
		links /
			<= Sheet_notify $easyreels_user_notify
				uri <= bot_uri \
			<= Library_open $mol_link
				arg *
					page \recordings
				title @ \Open My recordings
	Library $mol_page
		title <= library_title
		head <= library_head /
		tools /
			<= Lang $easyreels_i18n_switch
			<= Sign_out $mol_button_minor
				title @ \Sign out
				click? <=> sign_out? null
		body /
			<= Quota $easyreels_user_quota
				used_bytes <= used_bytes 0
				limit_bytes <= limit_bytes 0
			<= Library_notify $easyreels_user_notify
				uri <= bot_uri \
			<= Upload $easyreels_user_upload
			<= Recordings $easyreels_user_recordings
	Camera_link $mol_link
		arg *
			page null
		hint @ \Back to the camera
		sub /
			<= Camera_icon $mol_icon_camera
